import { AppQueryParams } from '../../constants/queryParams';

export const getIsOnePrefecture = (appQuery: AppQueryParams) => {
  const { pr, ci, wa, ar } = appQuery;
  return pr?.length === 1 && !ci?.length && !wa?.length && !ar?.length;
};
